<div class="registration--section-3">
    <div class="registration--section">
        <div class="registration--profile-info">
            <div class="registration--bullet-point" tabindex="0">
                {{ state.registrationPage.termsConditions.stepNumber }}
            </div>
            <h2 tabindex="0">{{ state.registrationPage.termsConditions.heading }}</h2>
        </div>
        <p class="registration--section-description" tabindex="0">
            {{ state.registrationPage.termsConditions.description }}
        </p>
    </div>
    <div class="registration--form-check">
        <div class="registration--check-div">
            <div>
                <input class="registration--check-box" type="checkbox" id="terms" name="terms"
                    [checked]="termsAndConditions" (click)="handleCheckboxClick($event)"
                    (keypress)="handleCheckboxClick($event)" tabindex="0" />
            </div>
            <label>
                {{state.registrationPage.termsConditions.terms.label | slice: 0:-7}}
                <a (click)="openModal('terms')" (keypress)="openModal('terms')"
                    tabindex="0">{{state.registrationPage.termsConditions.terms.tokenData[0].text}}</a>
            </label>
        </div>
        <div class="registration--check-div">
            <div>
                <input class="registration--check-box" type="checkbox" id="privacy" name="privacy"
                    [checked]="privacyPolicy" (click)="handleCheckboxClick($event)"
                    (keypress)="handleCheckboxClick($event)" tabindex="0" />
            </div>
            <label>
                {{state.registrationPage.termsConditions.privacy.label | slice: 0:-7}}
                <a id="privacyPolicy" (click)="openModal('privacy')" (keypress)="openModal('privacy')"
                    tabindex="0">{{state.registrationPage.termsConditions.privacy.tokenData[0].text}}</a>
            </label>
        </div>
    </div>
</div>
<div class="terms-conditions-modal">
<kng-modal-component [state]="state.termsModal" (ctaClickedOn)="agreeToConditionsOrPolicyAgreement($event)"
    (closed)="closeModal()" *ngIf="!state.termsModal.hidden" [checkBoxText]="checkBoxTermsData()" (checkBoxClicked)="checkIfTermsAgreed($event)" 
    [checBoxDisabledFlag]="checkBoxDisabledFlagTandC" [checkBoxTickedFlag]="checkBoxTickedFlagTandC" [isRegistrationRaymond]="true">
    <div #terms id="term-modal-tandc" tabindex="0" (scroll)="onScrollTandC($event)">
        <p *ngIf="isRaymond" class="scroll-note">{{state.registrationPage.termsConditions.terms.disclaimer}}</p>
        <div class="info-banner-terms" *ngIf="!isRaymond">
            <p class="info-banner-terms-text">{{state.registrationPage.termsConditions.terms.infoBanner}}</p>
        </div>
        <p id='content' *ngFor="let content of state.registrationPage.termsConditions.terms.modal.content" tabindex="0"
            [innerHTML]="content| safeHtml" role="dialog"></p>
    </div>
</kng-modal-component>
</div>

<div class="privacy-policy-modal">
<kng-modal-component *ngIf="!state.policyModal.hidden" [state]="state.policyModal"
    (ctaClickedOn)="agreeToConditionsOrPolicyAgreement($event)" (closed)="closeModal()" [checkBoxText]="checkBoxPrivacyData()" (checkBoxClicked)="checkIfPrivacyAgreed($event)" 
    [checBoxDisabledFlag]="checkBoxDisabledFlagPrivacy" [checkBoxTickedFlag]="checkBoxTickedFlagPrivacy" [isRegistrationRaymond]="true">
    <div class="privacy-policy" #policy id="term-modal-privacy" tabindex="0" (scroll)="onScrollPrivacy($event)">
        <p *ngIf="isRaymond" class="scroll-note">{{state.registrationPage.termsConditions.privacy.disclaimer}}</p>
        <div class="info-banner-privacy" *ngIf="!isRaymond">
            <p class="info-banner-privacy-text">{{state.registrationPage.termsConditions.privacy.infoBanner}}</p>
        </div>
        <p id='content' *ngFor="let content of state.registrationPage.termsConditions.privacy.modal.content"
            tabindex="0" [innerHTML]="content| safeHtml" role="dialog"></p>
    </div>
</kng-modal-component>
</div>